import { useSelectContext } from '../../select'
import type { SelectLabelProps, SelectScopedProps } from '../../select.types'
import { selectLabelVariants } from './index.styles'

export const SelectLabel = ({
  htmlFor,
  __scopeInputSelect,
  children,
}: SelectScopedProps<SelectLabelProps>) => {
  const { size, disabled, readOnly } = useSelectContext(
    'InputSelectLabel',
    __scopeInputSelect
  )

  return (
    <div className="flex h-extrasmall w-[100%] items-center rounded-none rounded-none border-none px-twopulse text-left">
      <label
        htmlFor={htmlFor}
        className={selectLabelVariants({ disabled, readOnly, size })}
        data-testid="testid-label"
      >
        {children}
      </label>
    </div>
  )
}
